import { ParticipationSetsGridColDef } from '../../types';
import { IssuerNameCellRenderer } from './IssuerNamerCellRenderer';

export type Value = string | undefined;

export const issuerColDef: ParticipationSetsGridColDef = {
  field: 'offering.issuer.name',
  headerName: 'Issuer',
  filter: 'agTextColumnFilter',
  pinned: 'left',
  width: 295,
  lockPinned: true,
  lockPosition: true,
  lockVisible: true,
  floatingFilter: true,
  cellRenderer: IssuerNameCellRenderer,
};
